import React from 'react';
import { Controller } from 'react-hook-form';

const Facilities = ({ isEditable, form, loading }) => {
  const handleValueChange = (item, currentValue, index, callback) => {
    const facility = [...currentValue];
    const newFacility = {
      id: item.id,
      name: item.name,
      icon: item.icon,
      is_checked: !item.is_checked
    };
    facility[index] = newFacility;
    callback(facility);
  };
  return (
    <div className="row x-gap-100 y-gap-15 mt-20">
      <div className="col-12">
        <div className="text-16 fw-500">Daftar Fasilitas :</div>
      </div>
      <div className="col-lg-12">
        <Controller
          control={form.control}
          name="facilities"
          render={({ field: { onChange, value } }) => (
            <div className="row y-gap-15">
              {value.map((item, index) => (
                <div key={item.id} className="col-3 mb-5">
                  <div className="d-flex items-center form-checkbox">
                    <input
                      disabled={!isEditable || loading}
                      type="checkbox"
                      name="name"
                      onChange={() => handleValueChange(item, value, index, onChange)}
                      checked={item.is_checked}
                    />
                    <div className="form-checkbox__mark">
                      <div className="form-checkbox__icon icon-check"></div>
                    </div>
                    <div className="text-15 lh-11 ml-20 fw-500 d-flex align-items-center">
                      <img src={item.icon} style={{ height: 25, width: 25, marginRight: 10 }} />
                      {item.name}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default Facilities;
